import { render, staticRenderFns } from "./ProviderInfoPopup.vue?vue&type=template&id=c472ef08&scoped=true&lang=html"
import script from "./ProviderInfoPopup.vue?vue&type=script&lang=js"
export * from "./ProviderInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./ProviderInfoPopup.vue?vue&type=style&index=0&id=c472ef08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c472ef08",
  null
  
)

export default component.exports